import { SVGProps } from 'react';

const SuccessIcon = ({
  height = '44px',
  width = '44px',
  strokeWidth = '2',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    id='Icons_Actions_ic-actions-check'
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 44 44'
    className='stroke-current'
    {...props}
  >
    <g id='ic-actions-check' transform='translate(4.757 4.757)'>
      <path
        id='Path_9'
        data-name='Path 9'
        d='M6.56,17.1l5.792,5.792,14.8-14.8'
        transform='translate(1.1 2.465)'
        fill='none'
        stroke='#45bf55'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        fillRule='evenodd'
      />
      <circle
        id='Ellipse_2'
        data-name='Ellipse 2'
        cx='17.838'
        cy='17.838'
        r='17.838'
        transform='translate(0 0)'
        fill='none'
        stroke='#45bf55'
        strokeLinecap='round'
        strokeLinejoin='bevel'
        strokeWidth={strokeWidth}
      />
    </g>
  </svg>
);

export default SuccessIcon;
